import isClient from 'utils/isClient'
import safedom from 'safedom'
import R from 'ramda'

const getAnimatedSections = () => safedom.selectAll('[data-show]')

const isSectionInactive = section => !section.classList.contains('is-section-visible')

const setSectionActive = safedom.addClass('is-section-visible')

const bindAnimatedSections = (animationObserver) => {
  getAnimatedSections()
    .map(R.forEach(R.when(isSectionInactive, section => animationObserver.observe(section))))
}

const animationObserver = () => {
  if (!isClient()) return

  if (!('IntersectionObserver' in window)) {
    getAnimatedSections().map(
      R.forEach(R.when(isSectionInactive, setSectionActive))
    )
    return
  }

  const intersectionConfig = {
    root: null,
    threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 1.0]
  }

  const limitFromBottom = window.innerHeight / 5
  const animationObserver = new IntersectionObserver(onIntersection, intersectionConfig)

  function onIntersection(entries, observer) {
    if (entries.length === 0) {
      observer.disconnect()
    }

    entries.forEach(entry => {
      if (entry.intersectionRect.height > limitFromBottom) {
        observer.unobserve(entry.target)
        setSectionActive(entry.target)
      }
    });
  }

  bindAnimatedSections(animationObserver)
}

export default animationObserver